import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api, tokenStore } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const applyAuth = (data) => {
    tokenStore.set(data.access_token);
    setUser(data.user);
    return data.user;
  };
  const login = async (email, password) => applyAuth((await api.post("/auth/login", { email, password })).data);
  const register = async (payload) => applyAuth((await api.post("/auth/register", payload)).data);
  const logout = async () => {
    try { await api.post("/auth/logout"); } catch { /* ignore */ }
    tokenStore.set(null);
    setUser(false);
  };

  return <AuthCtx.Provider value={{ user, login, register, logout, refresh }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
